{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "{conversationCount} conversations selected",
    "NONE": "None",
    "CLEAR_SELECTION": "Clear",
    "ASSIGN_AGENT_CONFIRMATION_LABEL": "Are you sure you want to assign {n} conversation to {agentName}? | Are you sure you want to assign {n} conversations to {agentName}?",
    "UNASSIGN_AGENT_CONFIRMATION_LABEL": "Are you sure you want to unassign {n} conversation? | Are you sure you want to unassign {n} conversations?",
    "YES": "Yes",
    "CANCEL": "Avbryt",
    "SEARCH_INPUT_PLACEHOLDER": "Søk",
    "ASSIGN_AGENT_TOOLTIP": "Assign agent",
    "ASSIGN_TEAM_TOOLTIP": "Assign team",
    "ASSIGN_SUCCESFUL": "Conversations assigned successfully.",
    "ASSIGN_FAILED": "Failed to assign conversations. Please try again.",
    "RESOLVE_SUCCESFUL": "Conversations resolved successfully.",
    "RESOLVE_FAILED": "Failed to resolve conversations. Please try again.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Conversations visible on this page are only selected.",
    "UPDATE": {
      "CHANGE_STATUS": "Change status",
      "SNOOZE_UNTIL": "Snooze",
      "UPDATE_SUCCESFUL": "Conversation status updated successfully.",
      "UPDATE_FAILED": "Failed to update conversations. Please try again."
    },
    "RESOLVE": {
      "ALL_MISSING_ATTRIBUTES": "Cannot resolve conversations due to missing required attributes",
      "PARTIAL_SUCCESS": "Some conversations need required attributes before resolving and were skipped"
    },
    "LABELS": {
      "ASSIGN_LABELS": "Assign labels",
      "REMOVE_LABELS": "Remove labels",
      "ASSIGN_SELECTED_LABELS": "Assign selected labels",
      "REMOVE_SELECTED_LABELS": "Remove selected labels",
      "ASSIGN_SUCCESFUL": "Labels assigned successfully.",
      "ASSIGN_FAILED": "Failed to assign labels. Please try again.",
      "REMOVE_SUCCESFUL": "Labels removed successfully.",
      "REMOVE_FAILED": "Failed to remove labels. Please try again."
    },
    "TEAMS": {
      "NONE": "None",
      "ASSIGN_TEAM_CONFIRMATION_LABEL": "Are you sure you want to assign {n} conversation to {teamName}? | Are you sure you want to assign {n} conversations to {teamName}?",
      "UNASSIGN_TEAM_CONFIRMATION_LABEL": "Are you sure you want to unassign {n} conversation? | Are you sure you want to unassign {n} conversations?",
      "ASSIGN_SUCCESFUL": "Teams assigned successfully.",
      "ASSIGN_FAILED": "Failed to assign team. Please try again."
    }
  }
}
